import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=2ec1d8db&scoped=true&"
import script from "./DashboardHeader.vue?vue&type=script&lang=js&"
export * from "./DashboardHeader.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHeader.vue?vue&type=style&index=0&id=2ec1d8db&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec1d8db",
  null
  
)

export default component.exports